export default "__VITE_ASSET__7yFxtRIN__"